import React from 'react'
import PropTypes from 'prop-types'

import './Slide.scss'

const Slide = ({ bg, title, year, text, progress, slideNum }) => {
  const bgStyle = `url(${bg})`
  let textStyle

  if (progress) { // if progress is number, adjusting style according to progress
    if (Number.isFinite(progress)) {
      textStyle = {
        transform: `translate3d(0, ${(progress > 0) ? ((1 - progress) * 50 + '%') : (-progress * 50 + '%')}, 0)`,
        opacity: (progress > 0) ? progress : 1 + progress
      }
    } else { // if progress is object, creating text's transition
      textStyle = {
        transform: `translate3d(0, ${(progress.duration > 0) ? '0%' : '50%'}, 0)`,
        opacity: (progress.duration > 0) ? 1 : 0,
        transition: `all ${Math.abs(progress.duration)}ms`
      }
    }
  }

  return (
    <div className='swiper-slide fi_slide'>
      <div id={`fi_slide__bg_${slideNum}`} className={`fi_slide__bg fi_slide__bg_${slideNum}`} style={{ backgroundImage: bgStyle }} />

      <div className='fi_slide__text' style={textStyle}>
        <h1 id={`fi_slide__title_${slideNum}`} className={`fi_slide__title fi_slide__title_${slideNum}`}>
          <span className={`fi_slide__title--text fi_slide__title_${slideNum}--text`}>{ title }</span>
        </h1>
        <div id={`fi_slide__year_${slideNum}`} className={`fi_slide__year fi_slide__year_${slideNum}`}>
          <span className={`fi_slide__year--text fi_slide__year_${slideNum}--text`}>{ year }</span>
        </div>
        <p id={`fi_slide__text_${slideNum}`} className={`fi_slide__text--p fi_slide__text_${slideNum}`}>{ text }</p>
      </div>
    </div>
  )
}

Slide.propTypes = {
  slideNum: PropTypes.number,
  bg: PropTypes.string,
  title: PropTypes.string,
  year: PropTypes.string,
  text: PropTypes.string,
  progress: PropTypes.oneOfType([PropTypes.number, PropTypes.object])
}

export default Slide



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/components/Slide.js